export default function TiktokIcon(params : React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...params} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.9992 2H12.645V15.6232C12.645 17.2464 11.355 18.5797 9.74958 18.5797C8.14418 18.5797 6.85413 17.2464 6.85413 15.6232C6.85413 14.029 8.11552 12.7246 9.6636 12.6667V9.24639C6.25211 9.30433 3.5 12.1159 3.5 15.6232C3.5 19.1594 6.30944 22 9.77826 22C13.247 22 16.0565 19.1304 16.0565 15.6232V8.63767C17.3179 9.56522 18.8659 10.1159 20.5 10.1449V6.72464C17.9773 6.63768 15.9992 4.55072 15.9992 2Z" fill="currentColor"/>
    </svg>
  );
}
